import { createSelector } from '@reduxjs/toolkit';
import filter from 'transmute/filter';
import { isStarted } from '../operators/isStarted';
// @ts-expect-error Untyped import
import { getThreadList } from './getThreadList';
export const getOpenThreads = createSelector([getThreadList],
// @ts-expect-error Transmute types are not good
filter(isStarted));